<template>
    <LayoutGradient :title="pageTitle" icon="fa-file-signature">
        <template v-slot:headerRight>
        <b-btn variant="outline-info" @click="$router.back()">
            <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
        </b-btn>
        </template>
        <b-card class="m-3 mt-n10">
            <SimpleForm :fields="fields" :model="model" @submit="onSubmit" class="tipo-form">
                <template v-slot:field(vns_integration_origin_id)>
                    <b-form-group :label="$t('result_conversion.form.integracao_origem')">
                        <b-overlay :show="isLoading">
                            <v-select
                                id="input-integracao_origem"
                                class="w-100"
                                :value="resultconversion.vns_integration_origin_id"                  
                                :options="integrations"
                                :reduce="option => option.id"
                                label="name"
                                v-model="model.vns_integration_origin_id"
                            />
                        </b-overlay>
                    </b-form-group>
                </template>

                <template v-slot:field(vns_integration_destination_id)>
                    <b-form-group :label="$t('result_conversion.form.integracao_destino')">
                        <b-overlay :show="isLoading">
                            <v-select
                                id="input-integracao_destino"
                                class="w-100"
                                :value="resultconversion.vns_integration_destination_id"
                                :options="integrations"
                                :reduce="option => option.id"
                                label="name"
                                v-model="model.vns_integration_destination_id"
                            />
                        </b-overlay>
                    </b-form-group>
                </template>
                <template v-slot:field(tuevs_exam_id)>
                    <b-form-group :label="$t('result_conversion.form.exame')">
                        <b-overlay :show="isLoading">
                            <SelectTuevsExam class="mb-3" v-model="model.tuevs_exam" :model="model.tuevs_exam" />
                        </b-overlay>
                    </b-form-group>
                </template>                
                <template #submitButton>
                    <b-button variant="success" type="submit" >
                        <i class="fas fa-save"/> Salvar
                    </b-button>
                </template>
            </SimpleForm>
        </b-card>
    </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ResultConversionRepository from '@/repositories/dexpara/ResultConversionRepository';
import {mapActions, mapGetters} from "vuex";
import SimpleForm from "@/components/FormGenerator/SimpleForm";
import SelectTuevsExam from "@/components/tuevs/Select/SelectTuevsExam";

export default {
    name: "Form",
    components: {LayoutGradient, SimpleForm, SelectTuevsExam, ResultConversionRepository},
    data() {
        return {
            resultconversion_id: null,
            fields: [
                {
                    label: this.$t('vns.form.fields.integracao_origem.label'),
                    name: 'vns_integration_origin_id',
                    description: this.$t('vns.form.fields.integracao_origem.description')
                },
                {
                    label: this.$t('vns.form.fields.integracao_destino.label'),
                    name: 'vns_integration_destination_id',
                    description: this.$t('vns.form.fields.integracao_destino.description')
                },
                {
                    label: this.$t('result_conversion.form.exame'),
                    name: 'tuevs_exam_id',
                    description: "Exame pertencente a configuração da conversão de resultado"
                },
                {
                    label: this.$t('result_conversion.form.operacao'),
                    name: 'operation',
                    description: this.$t('result_conversion.form.operacao_descricao')
                },
                {
                    label: "Status",
                    type: 'checkbox',
                    name: 'status',
                    description: this.$t('result_conversion.form.status_descricao')
                },
            ],
            model: {
                id: null,
                vns_integration_origin_id: '',
                vns_integration_destination_id: '',
                tuevs_exam_id: '',
                operation: '',
                status: false
            },
        }
    },
    computed: {
        ...mapGetters({
            resultconversion: 'dexpara/resultconversion/current',
            isLoading: 'dexpara/resultconversion/isLoading',
            integrations: 'integration/all',
            integrationsLoading: 'integration/isLoading'
        }),
        pageTitle() {
            if (this.resultconversion_id) return this.$t('result_conversion.form.titulo_editar')
            return this.$t('result_conversion.form.titulo_criar')
        },
    },
    methods: {
        ...mapActions([
            'dexpara/resultconversion/listOne',
            'integration/search',
        ]),
        async onSubmit(evt) {
            if (this.$route.params.id) {
                this.update()
            } else {
                this.create()
            }
        },
        create() {
            if (this.model.vns_integration_origin_id == '') {
                this.$snotify.error(this.$t('result_conversion.form.integracao_origem_obrigatoria'))
                return;
            }

            if (this.model.vns_integration_origin_id == '') {
                this.$snotify.error(this.$t('result_conversion.form.integracao_destino_obrigatoria'))
                return;
            }

            if (this.model.tuevs_exam === undefined) {
                this.$snotify.error(this.$t('result_conversion.form.exame_obrigatorio'))
                return;
            }

            this.model.tuevs_exam_id = this.model.tuevs_exam.value;

            const regex = /[^0-9,+-/\\*\\ ]/g;
            const foundInvalidOperation = this.model.operation.trim().match(regex);

            if (foundInvalidOperation) {
                this.$snotify.error(this.$t('result_conversion.form.regra_operacao_obrigatoria'))
                return;
            }

            ResultConversionRepository.post(this.model).then(() => {
                this.$snotify.success(this.$t('result_conversion.form.criada_sucesso'))
                this.$router.push({name: 'resultconversion'})
            }).catch(error => {
                if (error.response.status === 422) {
                    this.$snotify.error(error.response.data.message)
                }
            })
        },
        update() {
            if (this.model.vns_integration_origin_id == '') {
                this.$snotify.error(this.$t('result_conversion.form.integracao_origem_obrigatoria'))
                return;
            }

            if (this.model.vns_integration_origin_id == '') {
                this.$snotify.error(this.$t('result_conversion.form.integracao_destino_obrigatoria'))
                return;
            }

            if (this.model.tuevs_exam === undefined) {
                this.$snotify.error(this.$t('result_conversion.form.exame_obrigatorio'))
                return;
            }

            this.model.tuevs_exam_id = this.model.tuevs_exam.value;

            const regex = /[^0-9,+-/\\*\\ ]/g;
            const foundInvalidOperation = this.model.operation.trim().match(regex);

            if (foundInvalidOperation) {
                this.$snotify.error(this.$t('result_conversion.form.regra_operacao_obrigatoria'))
                return;
            }

            ResultConversionRepository.put(this.resultconversion_id, this.model).then(() => {
                this.$snotify.success(this.$t('result_conversion.form.editada_sucesso'))
                this.$router.push({name: 'resultconversion'})
            }).catch(error => {
                if (error.response.status === 422) {
                    this.$snotify.error(error.response.data.message)
                }
            })
        }
    },
    async mounted() {
        this.$store.commit('dexpara/resultconversion/setCurrent', {status: false})
        this['integration/search']()
        if (this.$route.params.id) {
            this.resultconversion_id = this.$route.params.id            
            await this['dexpara/resultconversion/listOne'](this.$route.params.id)
            this.model = {
                ...this.model,
                ...this.resultconversion.data.mappingResultConversion,                
                status: !!this.resultconversion.data.mappingResultConversion.status || false,
                tuevs_exam: { "label": this.resultconversion.data.mappingResultConversion.tuevs_exam_name, "value": this.resultconversion.data.mappingResultConversion.tuevs_exam_id }
            }
        }
    },
}
</script>
